import React, { useEffect, useState  } from 'react';
import { useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from 'react-router';

import Header from '@/views/components/Header/Header';
import Footer from '@/views/components/Footer/Footer';
import QuestionShort from '@/views/components/SimpleTextAdivse/QuestionShort/QuestionShort';
import TopSection from '@/views/components/SimpleTextAdivse/TopSection/TopSection';
import Pagination from '@/utils/pagination/Pagination';
import CheckActive from '@/assets/icons/simpleTextAdvices/check_icon.svg';
import CustomSelect from '@/views/components/CustomSelect/CustomSelect';
import Alert from '@/views/components/Alert/Alert';

import api from '@/services/api';
import { CheckPermission } from '@/utils/permissions/permissions';

import styles from '@/views/pages/SimpleTextAdvices/SimpleTextAdvices.module.scss';

const SimpleTextAdvices = () => {
	const [ categories, setCategories ] = useState([]);
	const [ questions, setQuestions ] = useState([]);
	const [ activeCategorie, setActiveCategories ] = useState(null);
	const [ selectActiveCategorie, setSelectActiveCategorie ] = useState(null);
	const [ pages, setPages ] = useState(1);
	const [ hits, setHits ] = useState(null);
	const [ randomAdvice, setRandomAdvices ] = useState(null);
	const [ alert, setAlert ] = useState(null);

	const user = useSelector((state) => state.auth.user);
	const dict = useSelector(state => state.app.dict);
	const userRole = user && user.role;

	const location = useLocation();
	const navigate = useNavigate();

	const { search: locationSearch, pathname } = location;

	const itemsPerPager = 20;
	const getQuestions = async () => {
		const params = new URLSearchParams(locationSearch);

		try {
			const {data} = await api.get(`/questions?perpage=${itemsPerPager}&${params}`);
			setPages(data.pages);
			setHits(data.hits);
			setQuestions(data.questions);
		} catch (error) {
			setAlert({content: dict.simpleTextAdvices.findAdvice.alert.questions, variant: 'error'});
		}
		
	};

	const getRandomAdvice = async () => {
		try {
			const {data} = await api.get(`/questions/random`);

			setRandomAdvices(data.id);
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};

	const getCategories = async() => {
		try {
			const {data} = await api.get('/questions/categories');

			const newCategories = data.map(cat => ({
				id: cat.id,
				label: cat.name,
				value: cat.id,
			}));

			newCategories.unshift({
				id: 0,
				label: dict.simpleTextAdvices.findAdvice.allCategories,
				value: 0,
			});

			setCategories(newCategories);
			const params = new URLSearchParams(locationSearch);
			const activeCat = params.get('categoryId');

			if(activeCat) {
				const active = newCategories.find(cat => cat.id === Number(activeCat));
				setActiveCategories(active.id);
				setSelectActiveCategorie(active);
			} else {
				setActiveCategories(newCategories[0].id);
				setSelectActiveCategorie(newCategories[0]);
			}
		} catch (error) {
			setAlert({content: dict.simpleTextAdvices.findAdvice.alert.category, variant: 'error'});
		}
		
	};

	useEffect(() => {
		getQuestions();
		getCategories();
		getRandomAdvice();
	}, [ ]);

	useEffect(() => {
		const params = new URLSearchParams(locationSearch);
		params.delete('page');
		navigate(`${pathname}?${params}`);
	}, [ activeCategorie ]);

	useEffect(() => {
		getQuestions();
	}, [ locationSearch ]);

	const handleCloseAlert = () => {
		setAlert(null);
	};

	const handleChangeCategorie = (item) => {
		setSelectActiveCategorie(item);
		setActiveCategories(item.id);
		const params = new URLSearchParams(locationSearch);
		if(item.id != 0) {
			params.set('categoryId', item.id);
		} else {
			params.delete('categoryId');
		}

		navigate(`${pathname}?${params}`);
	};
	
	return (
		<>
			<Header narrow={ false } />
			<div className={ styles['advises__container'] }>
				{alert && <Alert 
					variant={ alert.variant }
					alertContent={ alert.content }
					closeAction={ ()=> handleCloseAlert() }
				/>}
				<TopSection 
					description={ dict.simpleTextAdvices.findAdvice.description }
					subTitle={ dict.simpleTextAdvices.findAdvice.subHeader }
				>
					{randomAdvice && <Link 
						className='button__white'
						to={ `/simple-text-advice/${randomAdvice}` }
					>
						{dict.simpleTextAdvices.findAdvice.randomAdvice}
					</Link>}
					{CheckPermission("canAskQuestions", userRole) && 
						<Link className='button__blue'
							to={ `/simple-text-my-advices` }>
							{dict.simpleTextAdvices.findAdvice.myQuestions} <div className={ `icon-arrow-right-full` } />
						</Link>}
				</TopSection>
				<div className={ styles['advises__select'] }>
					<CustomSelect
						options={ categories } 
						value={ selectActiveCategorie }
						onChange={ handleChangeCategorie }
						placeholder=""
						label='Kategoria'
					/> 
				</div>
				<div className={ styles['advises__container-grid'] }>
					<div className={ styles['advises__categories'] }>
						<div className={ styles['advises__categories__title'] }>
							<p className={ styles['advises__categories__title__text'] }>{dict.simpleTextAdvices.findAdvice.category}</p>
						</div>
						<div className={ styles['advises__categories__items'] }>
							{categories.length > 0 && categories.map((cat) => (
								<div 
									onClick={ () => handleChangeCategorie(cat) }
									key={ cat.id }
									className={ cat.id === activeCategorie ? `${styles['advises__categories__item']} ${styles['advises__categories__item--active']}` : styles['advises__categories__item'] } >
									<>
										<img 
											className={ cat.id === activeCategorie ? styles['advises__categories__icon'] : styles['advises__categories__icon--hidden'] }
											src={ CheckActive }
											alt={ dict.simpleTextAdvices.findAdvice.checkMark } />
									</>
									<p className={ styles['advises__categories__name'] }>{cat.label}</p>
								</div>
							))}
						</div>
					</div>
					<div>
						<Pagination
							pagesNum={ pages }
							sortingOptions={ null }
							sortingValue={ null }
							sortingOnChange={ null }
							alignRight={ true }
						>
							<p className={ styles['advises__questions__header'] }>{dict.simpleTextAdvices.findAdvice.advices} ({hits})</p>
							<div>
								{questions && questions.length > 0 && questions.map(question => 
									<QuestionShort 
										key={ question.id }
										question={ question }
										isPublic
									/>,
								) }
								{!questions || questions.length === 0 && <div className={ styles['advises__not-found'] }>
									Brak porad do wyświetlenia.
								</div> }
							</div>
						</Pagination>
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
};

export default SimpleTextAdvices;